<div class="lum-c-order-ordered-items-table">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <th class="px-2 w-8  text-right text-muted"></th>
        <th *ngIf="hasLineWithCustomFields" class="px-1 w-5">
          <button
            type="button"
            class="linkish  text-default"
            (click)="onToggleExpandAll()"
          >
            <i
              class="fas fa-fw fa-sm"
              [ngClass]="areAllExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
          </button>
        </th>
        <th>Item Name</th>
        <th>SKU</th>
        <th class="text-right">
          <span matTooltip="Quantity Ordered/Submitted/Shipped"
            >Quantity (O/S/S)</span
          >
        </th>
        <th class="text-left">Unit</th>
        <th>Price</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of orderItems; let i = index">
        <tr>
          <td class="px-2 w-8  text-right text-muted">{{ i + 1 }}</td>
          <td *ngIf="hasLineWithCustomFields" class="px-1 w-5">
            <button
              *ngIf="(item.customFieldValues?.length ?? 0) > 0"
              type="button"
              class="linkish  text-default"
              (click)="onToggleExpand(item)"
            >
              <i
                class="fas fa-fw fa-sm"
                [ngClass]="item.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              ></i>
            </button>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.sku }}</td>
          <td class="text-right">
            <span
              [matTooltip]="
                (item?.quantity | decimalPlaces) +
                ' Ordered / ' +
                (item?.quantityFulfilled | decimalPlaces) +
                ' Submitted / ' +
                (item?.quantityShipped | decimalPlaces) +
                ' Shipped'
              "
            >
              <span>{{ item?.quantity | decimalPlaces }}</span>
              <span class="pl-2 pr-2">/</span>
              <span>{{ item?.quantityFulfilled | decimalPlaces }}</span>
              <span class="pl-2 pr-2">/</span>
              <span>{{ item?.quantityShipped | decimalPlaces }}</span>
            </span>
          </td>
          <td class="text-left">{{ item?.orderedUom?.name }}</td>
          <td>{{ item?.unitPrice | lumCurrency }}</td>
          <td>{{ item?.quantity * item?.unitPrice | lumCurrency }}</td>
        </tr>
        <tr *ngIf="item.isExpanded">
          <td colspan="2"></td>
          <td colspan="6">
            <dl class="dl-grid gap-x-4 gap-y-1">
              <ng-container *ngFor="let field of item.customFieldValues">
                <dt>{{ field.customField.label }}</dt>
                <dd>
                  <lum-ui-copyable
                    [content]="
                      field.valueString ??
                      field.valueNumber ??
                      field.valueDate ??
                      ''
                    "
                  ></lum-ui-copyable>
                </dd>
              </ng-container>
            </dl>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
